import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Hero = () => {
  return (
    <div className="relative min-h-screen flex items-start justify-center overflow-hidden pt-12">
      <div
        className="absolute inset-0 top-0 bg-cover bg-center bg-fixed scale-105"
        style={{ backgroundImage: `url('/images/background-kolektif.jpeg')` }}
      />
      <div className="absolute inset-0 top-0 bg-gradient-to-b from-black/90 via-black/50 to-black/80" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 w-full pt-32 sm:pt-40"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="flex justify-center mb-10"
            >
              <div className="relative group">
                <div className="absolute -inset-1.5 bg-white/20 rounded-full blur-xl group-hover:bg-white/30 transition-all duration-300" />
                <img
                  src="/images/kolektif.jpeg"
                  alt="Kolektif Oluşum"
                  className="relative h-32 w-32 sm:h-36 sm:w-36 rounded-full shadow-2xl ring-4 ring-white/30 object-cover transform group-hover:scale-105 transition-transform duration-300"
                />
              </div>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="relative"
            >
              <span className="block text-5xl sm:text-7xl md:text-8xl font-bold text-white tracking-wide [text-shadow:_0_2px_4px_rgb(0_0_0_/_60%)]">
                Kolektif Oluşum
              </span>
              <span className="block text-lg italic sm:text-2xl md:text-3xl text-blue-300 mt-6 sm:mt-8 tracking-wider [text-shadow:_0_1px_2px_rgb(0_0_0_/_60%)]">
                Türkiye'nin ve Avrupa'nın En Büyük Öğrenci Ağı
              </span>
            </motion.h1>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              className="mt-12 sm:mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8"
            >
              <Link
                to="/hakkimizda"
                className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-blue-600 text-white text-lg sm:text-xl rounded-2xl shadow-lg hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center justify-center"
              >
                Hakkımızda
              </Link>
              <Link
                to="/etkinliklerimiz/"
                className="w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-white/10 hover:backdrop-blur-md text-white text-lg sm:text-xl rounded-2xl border-2 border-white/20 shadow-lg hover:bg-white/20 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center justify-center"
              >
                Etkinliklerimiz
              </Link>
            </motion.div>
          </div>
        </div>
      </motion.div>

      <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-black/80 to-transparent" />
    </div>
  );
};

export default Hero;
